// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

var focusRef = (function(ref) {
    var el = ref.current;
    if (el && el.focus) el.focus();
  });

var execCommand = (function(command, value) {
    document.execCommand(command, false, value || null);
  });

var getRefHtml = (function(ref) {
    var el = ref.current;
    return el ? el.innerHTML : "";
  });

var setRefHtml = (function(ref, html) {
    var el = ref.current;
    if (el && el.innerHTML !== html) {
      el.innerHTML = html;
    }
  });

var queryCommandState = (function(command) {
    try {
      return document.queryCommandState(command);
    } catch (e) {
      return false;
    }
  });

var setLinkTargetAndRel = (function() {
    var sel = document.getSelection();
    if (!sel || sel.rangeCount === 0) return;
    var range = sel.getRangeAt(0);
    var container = range.commonAncestorContainer;
    var el = container.nodeType === 3 ? container.parentElement : container;
    if (el && el.closest) {
      var a = el.closest("a");
      if (a) {
        a.setAttribute("target", "_blank");
        a.setAttribute("rel", "noopener noreferrer");
      }
    }
  });

var isSelectionInEditor = (function(ref) {
    var editor = ref.current;
    if (!editor) return false;
    var sel = document.getSelection();
    if (!sel || sel.rangeCount === 0) return false;
    var node = sel.anchorNode;
    return node && editor.contains(node);
  });

var applyAlignment = (function(ref, align) {
    var editor = ref.current;
    if (!editor) return;
    var sel = document.getSelection();
    if (!sel || sel.rangeCount === 0) return;
    var range = sel.getRangeAt(0);
    if (!editor.contains(range.commonAncestorContainer)) return;

    var command = "justifyLeft";
    if (align === "center") command = "justifyCenter";
    else if (align === "right") command = "justifyRight";
    else if (align === "justify") command = "justifyFull";
    document.execCommand(command, false, null);
  });

var getSelectionAlignment = (function(ref) {
    var editor = ref.current;
    if (!editor) return "";
    var sel = document.getSelection();
    if (!sel || sel.rangeCount === 0) return "";
    var range = sel.getRangeAt(0);
    if (!editor.contains(range.commonAncestorContainer)) return "";
    try {
      if (document.queryCommandState("justifyCenter")) return "center";
      if (document.queryCommandState("justifyRight")) return "right";
      if (document.queryCommandState("justifyFull")) return "justify";
      if (document.queryCommandState("justifyLeft")) return "left";
    } catch (e) {
      return "";
    }
    return "";
  });

var saveSelection = ((function() {
    var lastRange = null;
    return function(ref) {
      var editor = ref.current;
      if (!editor) return;
      var sel = document.getSelection();
      if (!sel || sel.rangeCount === 0) return;
      var range = sel.getRangeAt(0);
      if (!editor.contains(range.commonAncestorContainer)) return;
      lastRange = range.cloneRange();
      editor.__lastRange = lastRange;
    };
  })());

var restoreSelection = (function(ref) {
    var editor = ref.current;
    if (!editor || !editor.__lastRange) return;
    var sel = document.getSelection();
    if (!sel) return;
    sel.removeAllRanges();
    sel.addRange(editor.__lastRange);
  });

function RichTextToolbar$TextColorPicker(props) {
  var onSelectColor = props.onSelectColor;
  var match = React.useState(function (param) {
        return "#374151";
      });
  var setCurrentColor = match[1];
  var currentColor = match[0];
  return JsxRuntime.jsxs("label", {
              children: [
                JsxRuntime.jsx("span", {
                      children: "A",
                      className: "text-xs font-bold leading-none text-gray-800"
                    }),
                JsxRuntime.jsx("span", {
                      className: "block w-3 mt-0.5 rounded-sm",
                      style: {
                        backgroundColor: currentColor,
                        height: "3px"
                      }
                    }),
                JsxRuntime.jsx("input", {
                      className: "cursor-pointer border-0 p-0 m-0 overflow-hidden absolute inset-0 w-full h-full opacity-0",
                      type: "color",
                      value: currentColor,
                      onChange: (function ($$event) {
                          var hex = $$event.target.value;
                          Curry._1(setCurrentColor, (function (param) {
                                  return hex;
                                }));
                          Curry._1(onSelectColor, hex);
                        })
                    })
              ],
              "aria-label": "Pick text color",
              className: "relative inline-flex flex-col items-center justify-center cursor-pointer select-none bg-white hover:bg-gray-50 border border-gray-200 rounded max-h-5 max-w-5 h-5 w-5 transition-colors shadow-sm",
              title: "Text color"
            });
}

var TextColorPicker = {
  make: RichTextToolbar$TextColorPicker
};

function RichTextToolbar$ToolbarButton(props) {
  var __active = props.active;
  var __className = props.className;
  var onAction = props.onAction;
  var title = props.title;
  var className = __className !== undefined ? __className : "";
  var active = __active !== undefined ? __active : false;
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("span", {
                    dangerouslySetInnerHTML: {
                      __html: props.label
                    }
                  }),
              "aria-label": title,
              className: "max-w-5 max-h-5 inline-flex items-center justify-center px-1.5 py-1 text-xs border rounded cursor-pointer select-none transition-colors " + className + " " + (
                active ? "border-gray-400 bg-gray-200 text-gray-900 shadow-inner" : "border-gray-200 bg-white text-gray-700 hover:bg-gray-100 shadow-sm"
              ),
              title: title,
              type: "button",
              onMouseDown: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onAction, undefined);
                })
            });
}

var ToolbarButton = {
  make: RichTextToolbar$ToolbarButton
};

function RichTextToolbar$HyperlinkInput(props) {
  var onCancel = props.onCancel;
  var onApply = props.onApply;
  var match = React.useState(function (param) {
        return "";
      });
  var setLinkText = match[1];
  var linkText = match[0];
  var match$1 = React.useState(function (param) {
        return "https://";
      });
  var setUrl = match$1[1];
  var url = match$1[0];
  var linkTextInputRef = React.useRef(null);
  React.useEffect((function (param) {
          focusRef(linkTextInputRef);
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Link text",
                              className: "text-sm text-gray-600 whitespace-nowrap w-20",
                              htmlFor: "hyperlink-text"
                            }),
                        JsxRuntime.jsx("input", {
                              ref: Caml_option.some(linkTextInputRef),
                              "aria-label": "Link text",
                              className: "text-sm border border-gray-200 rounded-md px-3 py-2 flex-1 outline-none focus:border-bleudefrance focus:ring-1 focus:ring-bleudefrance",
                              id: "hyperlink-text",
                              placeholder: "e.g. Read more",
                              type: "text",
                              value: linkText,
                              onChange: (function ($$event) {
                                  var v = $$event.target.value;
                                  Curry._1(setLinkText, (function (param) {
                                          return v;
                                        }));
                                })
                            })
                      ],
                      className: "flex items-center gap-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "URL",
                              className: "text-sm text-gray-600 whitespace-nowrap w-20",
                              htmlFor: "hyperlink-url"
                            }),
                        JsxRuntime.jsx("input", {
                              "aria-label": "Link URL",
                              className: "text-sm border border-gray-200 rounded-md px-3 py-2 flex-1 outline-none focus:border-bleudefrance focus:ring-1 focus:ring-bleudefrance",
                              id: "hyperlink-url",
                              placeholder: "https://example.com",
                              type: "text",
                              value: url,
                              onKeyDown: (function ($$event) {
                                  var key = $$event.key;
                                  if (key === "Enter") {
                                    $$event.preventDefault();
                                    return Curry._2(onApply, linkText, url);
                                  } else if (key === "Escape") {
                                    return Curry._1(onCancel, undefined);
                                  } else {
                                    return ;
                                  }
                                }),
                              onChange: (function ($$event) {
                                  var v = $$event.target.value;
                                  Curry._1(setUrl, (function (param) {
                                          return v;
                                        }));
                                })
                            })
                      ],
                      className: "flex items-center gap-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: "Apply",
                              className: "text-sm px-3 py-2 bg-bleudefrance text-white rounded-md hover:bg-blue-600 transition-colors cursor-pointer font-medium",
                              type: "button",
                              onClick: (function (param) {
                                  Curry._2(onApply, linkText, url);
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Close",
                              "aria-label": "Close",
                              className: "text-sm px-2 py-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors cursor-pointer",
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onCancel, undefined);
                                })
                            })
                      ],
                      className: "flex items-center gap-2 flex-wrap"
                    })
              ],
              "aria-label": "Insert hyperlink",
              className: "flex flex-col gap-3 py-3 px-3 bg-white border border-gray-200 rounded-lg shadow-md mt-2 mb-1",
              role: "group"
            });
}

var HyperlinkInput = {
  make: RichTextToolbar$HyperlinkInput
};

exports.focusRef = focusRef;
exports.execCommand = execCommand;
exports.getRefHtml = getRefHtml;
exports.setRefHtml = setRefHtml;
exports.queryCommandState = queryCommandState;
exports.setLinkTargetAndRel = setLinkTargetAndRel;
exports.isSelectionInEditor = isSelectionInEditor;
exports.applyAlignment = applyAlignment;
exports.getSelectionAlignment = getSelectionAlignment;
exports.saveSelection = saveSelection;
exports.restoreSelection = restoreSelection;
exports.TextColorPicker = TextColorPicker;
exports.ToolbarButton = ToolbarButton;
exports.HyperlinkInput = HyperlinkInput;
/* saveSelection Not a pure module */
